import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "./App.css";

// Import pages
import Home from "./pages/Home";
import About from "./pages/About";
import HowItWorks from "./pages/HowItWorks";
import Collaborate from "./pages/Collaborate";
import DemoRequest from "./pages/DemoRequest";
import LoginPage from "./pages/Login";
import Dashboard from "./userscreens/Dashboard";
import MyReceipts from "./userscreens/MyReceipts";
import MyAccount from "./userscreens/MyAccount";
import Password from "./userscreens/Password-Security";
import FeedbackForm from "./userscreens/Feedback";

const RouteConfig = ({ isAuthenticated, onLogin }) => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/collaborate" element={<Collaborate />} />
      <Route path="/demo-request" element={<DemoRequest />} />
      <Route path="/login" element={<LoginPage onLogin={onLogin} />} />
      {isAuthenticated ? (
        <>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/my-receipts" element={<MyReceipts />} />
          <Route path="/my-acount" element={<MyAccount />} />
          <Route path="/chg-pwd" element={<Password />} />
          <Route path="/febak" element={<FeedbackForm />} />
        </>
      ) : <>  <Route path="/login" /> </>}
    </Routes>
  );
};

export default RouteConfig;
